





























import {
  Vue, Component, Prop, Model, Emit,
} from 'vue-property-decorator';
import ButtonInput from '../../components/ui/ButtonInput.vue';
import CurrentWord from './CurrentWord.vue';
import ICurrentWord from '@/types/ICurrentWord';
import QuizCommand from '@/types/QuizCommand';
import messageBus from '../../utils/MessageBus';


// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    ButtonInput,
    CurrentWord,
  },
})
export default class QuizArea extends Vue {
  playing: boolean = false;
  disabled: boolean = false;

  @Prop() currentWord!: ICurrentWord;
  @Prop() error!: object;

  @Model('input', { type: String }) readonly submission!: string;

  get submissionVal() {
    return this.submission;
  }

  set submissionVal(v) {
    this.$emit('input', v);
  }

  // noinspection JSUnusedGlobalSymbols
  get highlighted() {
    return this.playing;
  }

  // noinspection JSMethodCanBeStatic
  playCurrentWord(): void { // eslint-disable-line class-methods-use-this
    messageBus.$emit('quizCommand', QuizCommand.Play);
  }

  // noinspection JSMethodCanBeStatic
  submitAnswer(): void { // eslint-disable-line class-methods-use-this
    messageBus.$emit('quizCommand', QuizCommand.Check);
  }

  onAudioPlaying(isPlaying: boolean) {
    this.playing = isPlaying;
  }

  onEnableInput(isEnabled: boolean) {
    this.disabled = !isEnabled;
  }


  // noinspection JSUnusedGlobalSymbols
  mounted() {
    // handler to play audio of current word
    messageBus.$on('audioPlaying', this.onAudioPlaying);

    // handler to enable/disable input
    messageBus.$on('enableInput', this.onEnableInput);
  }

  // noinspection JSUnusedGlobalSymbols
  beforeDestroy() {
    messageBus.$off('audioPlaying', this.onAudioPlaying);
    messageBus.$off('enableInput', this.onEnableInput);
  }
}
